/* eslint-disable */
const AddTableRowBelowIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" focusable="false" className="icon icon-tabler icon-tabler-row-insert-bottom" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <path d="M20 6v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1z" />
      <line x1="12" y1="15" x2="12" y2="19" />
      <line x1="14" y1="17" x2="10" y2="17" />
    </svg>
  )
}

export default AddTableRowBelowIcon;